// PostHog analytics — deferred + gated.
//
// Why this file exists:
//   The original PostHog snippet lived in `public/index.html` and ran
//   synchronously on every page load, including `/login`. That added 6+
//   external script downloads + session-recording overhead BEFORE the
//   login form could render. We moved init into this module so it only
//   fires AFTER the user is authenticated, on the browser idle phase,
//   and fails silent if anything goes wrong.
//
// Notes:
//   - We keep the same project key + config the snippet had.
//   - Init runs at most once per page load (guarded by `__mm_ph_init`).
//   - We never block first paint and never throw — analytics is best
//     effort, never load-bearing.

const POSTHOG_KEY = "phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs";
const POSTHOG_API_HOST = "https://us.i.posthog.com";

function loadPostHogSnippet() {
  // Idempotency: don't load twice.
  if (typeof window === "undefined") return;
  if (window.__mm_ph_init) return;
  window.__mm_ph_init = true;
  try {
    // Same boilerplate as the public/index.html snippet, ported to a
    // function so it runs deferred (after login) instead of synchronously
    // at HTML parse time.
    /* eslint-disable */
    !(function (t, e) {
      var o, n, p, r;
      e.__SV || ((window.posthog = e), (e._i = []), (e.init = function (i, s, a) {
        function g(t, e) {
          var o = e.split(".");
          2 == o.length && ((t = t[o[0]]), (e = o[1])),
            (t[e] = function () {
              t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
            });
        }
        ((p = t.createElement("script")).type = "text/javascript"),
          (p.crossOrigin = "anonymous"),
          (p.async = !0),
          (p.src = s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") + "/static/array.js"),
          (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(p, r);
        var u = e;
        for (
          void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
            u.people = u.people || [],
            u.toString = function (t) {
              var e = "posthog";
              return "posthog" !== a && (e += "." + a), t || (e += " (stub)"), e;
            },
            u.people.toString = function () { return u.toString(1) + ".people (stub)"; },
            o = "init me ws ys ps bs capture je Di ks register register_once register_for_session unregister unregister_for_session Ps getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey canRenderSurveyAsync identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty Es $s createPersonProfile Is opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing Ss debug xs getPageViewId captureTraceFeedback captureTraceMetric".split(" "),
            n = 0;
          n < o.length;
          n++
        )
          g(u, o[n]);
        e._i.push([i, s, a]);
      }), (e.__SV = 1));
    })(document, window.posthog || []);

    window.posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_API_HOST,
      person_profiles: "identified_only",
      session_recording: {
        recordCrossOriginIframes: true,
        capturePerformance: false,
      },
    });
    /* eslint-enable */
  } catch (_err) {
    // Never break the app because of analytics.
  }
}

// Run PostHog init off the critical path:
//   1. user must be authenticated (caller decides — they pass `user`)
//   2. browser idle, or 1.5s after the call as a fallback
export function initAnalyticsAfterAuth(user) {
  if (!user || typeof window === "undefined") return;
  if (window.__mm_ph_init) {
    // Already loaded — just identify (cheap, can run multiple times).
    try { window.posthog?.identify?.(user.id || user.email, { email: user.email, role: user.role }); } catch {}
    return;
  }
  const runDeferred = () => {
    loadPostHogSnippet();
    try { window.posthog?.identify?.(user.id || user.email, { email: user.email, role: user.role }); } catch {}
  };
  try {
    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(runDeferred, { timeout: 1500 });
    } else {
      setTimeout(runDeferred, 800);
    }
  } catch {
    // best-effort — never throw from analytics
    setTimeout(runDeferred, 800);
  }
}
